import { SidebarItem } from "./SidebarItem";
import { useEffect } from "react";
import MyLink from "@/components/shared/myLink/MyLink";
import { usePathname } from "next/navigation";
import { SidebarLinkItem } from "../../SidebarLink";
import useContentCollapse from "@/sharedHooks/useContentCollapse";
import getPurePathName from "@/utils/lang/getPurePathName";

function Links({ parent }: { parent: SidebarLinkItem }) {
  const pathname = usePathname();

  const { unitStatus, setUnitStatus, openHeight, Element, handleCollapse } =
    useContentCollapse();

  const pathnamePure = getPurePathName(pathname);
  const isDirectActive =
    parent.type === "link" && pathnamePure === parent.href;
  const hasActiveChild =
    parent.children?.some(
      (child) =>
        pathnamePure === child.href ||
        Boolean(child.activeName && pathname.includes(child.activeName))
    ) || false;

  useEffect(() => {
    if (hasActiveChild) setUnitStatus(true);
  }, [hasActiveChild, setUnitStatus]);

  return (
    <div className="flex w-full flex-col text-slate-500">
      {parent.type === "link" && (
        <MyLink
          className={`relative flex h-11 w-full items-center rounded-xl px-3 transition-all duration-200 ${
            isDirectActive
              ? "bg-[#1F0570] text-white shadow-[0_8px_20px_rgba(31,5,112,0.18)]"
              : "hover:bg-violet-50 hover:text-[#1F0570]"
          }`}
          href={parent.href || "#"}
        >
          <SidebarItem parent={parent} active={isDirectActive} />
        </MyLink>
      )}
      {parent.type === "toggle" && (
        <button
          type="button"
          aria-expanded={unitStatus}
          className={`flex h-11 w-full cursor-pointer items-center rounded-xl px-3 text-start transition-all duration-200 ${
            hasActiveChild
              ? "bg-[#1F0570] text-white shadow-[0_8px_20px_rgba(31,5,112,0.18)]"
              : unitStatus
              ? "bg-violet-50 text-[#1F0570]"
              : "hover:bg-violet-50 hover:text-[#1F0570]"
          }`}
          onClick={handleCollapse}
        >
          <SidebarItem
            unitStatus={unitStatus}
            parent={parent}
            arrow
            active={hasActiveChild}
          />
        </button>
      )}

      <div
        ref={Element}
        style={{ height: unitStatus ? openHeight : "0" }}
        className="w-full overflow-hidden transition-[height] duration-300"
      >
        <div className="relative ms-5 mt-1 space-y-0.5 border-s border-violet-100 ps-3">
          {parent.children?.map((el, idx) => {
            const isChildActive =
              pathnamePure === el.href ||
              Boolean(el.activeName && pathname.includes(el.activeName));
            return (
            <MyLink
              key={`${el.id || el.href}-${idx}`}
              className={`relative flex h-9 w-full items-center rounded-lg px-3 text-sm transition ${
                isChildActive
                  ? "bg-violet-50 font-bold text-[#1F0570]"
                  : "text-slate-400 hover:bg-slate-50 hover:text-slate-700"
              }`}
              href={el.href || "#"}
            >
              <span
                className={`absolute -start-[17px] h-2 w-2 rounded-full border-2 border-white ${
                  isChildActive ? "bg-[#1F0570]" : "bg-slate-200"
                }`}
              />
              <p className="w-full truncate text-start">{el.label}</p>
            </MyLink>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Links;
